<tt-list [ttData]="kpiData"></tt-list>
